import FileDownload from 'js-file-download';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';
import { actionSuccess } from '../utils';
import { LOADING_START } from '../loading/loadingActions';

export const FETCH_LIQUIDATION_LIST = 'FETCH_LIQUIDATION_LIST';
export const LOADING_END = 'LOADING_END';

export const fetchLiquidationList =
  (filters = {}, getLiquidationList) =>
  async dispatch => {
    try {
      dispatch({ type: LOADING_START });
      const response = await getLiquidationList(filters);

      dispatch(actionSuccess(FETCH_LIQUIDATION_LIST, response));

      return response;
    } catch (error) {
      dispatch(addToast(toastTypes.error, error));
    } finally {
      dispatch({ type: LOADING_END });
    }
  };

const downloadPayflowFile = (data, period) => {
  const fileName = `payflow-${period}-Lista-de-liquidación.xlsx`;

  FileDownload(data, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
};

export const downloadLiquidationFile = async (period, getFileData, dispatch) => {
  try {
    const data = await getFileData(period);
    downloadPayflowFile(data, period);
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};
